export const SimulacaoErrorCodes = {
  PRODUCT_WITHOUT_VALID_CONDITION_OR_PRICE_TABLE: 'PRODUCT_WITHOUT_VALID_CONDITION_OR_PRICE_TABLE',
  PRODUCT_NOT_AVAILABLE_FOR_SIMULATION: 'PRODUCT_NOT_AVAILABLE_FOR_SIMULATION',
} as const

export type SimulacaoErrorCode = (typeof SimulacaoErrorCodes)[keyof typeof SimulacaoErrorCodes]

export const isSimulacaoErrorCode = (code: string): code is SimulacaoErrorCode => {
  return Object.values(SimulacaoErrorCodes).includes(code as SimulacaoErrorCode)
}

export const getSimulacaoErrorMessage = (code: SimulacaoErrorCode): string => {
  const errorMessages: Record<SimulacaoErrorCode, string> = {
    [SimulacaoErrorCodes.PRODUCT_NOT_AVAILABLE_FOR_SIMULATION]: 'Produto não está mais disponível',
    [SimulacaoErrorCodes.PRODUCT_WITHOUT_VALID_CONDITION_OR_PRICE_TABLE]:
      'Não é possível duplicar a simulação, o produto não tem condição e tabela de preço vigente',
  }

  return errorMessages[code]
}
